<template>
  <div class="msg-option">
    <div :class="['left', active === 1 ? 'active' : '']" @click="handleHelp(1)">
      <i class="kf-like"></i>
      {{ $t("faqDetail.有帮助") }}
    </div>
    <div
      :class="['right', active === -1 ? 'active' : '']"
      @click="handleHelp(-1)"
    >
      <i class="kf-like rotate"></i>
      {{ $t("faqDetail.没帮助") }}
    </div>
  </div>
</template>

<script>
import { apiRobotGrade } from "@/api/Im";
import { mapGetters } from "vuex";

export default {
  name: "MsgOption",
  props: {
    msg_id: {
      type: [String, Number],
      default: "",
    },
    grade: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    ...mapGetters(["defaultRoleInfo", "vuexInitData"]),
  },
  watch: {
    grade: {
      handler(val) {
        if (val) {
          this.active = Number(val);
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      active: "",
    };
  },
  methods: {
    handleHelp(type) {
      if (this.active) {
        return;
      }
      if (this.active === type) {
        return;
      }
      this.active = type;

      const params = {
        im_role_id: this.defaultRoleInfo.id,
        msg_id: this.msg_id,
        score: type,
        sess_uuid: this.vuexInitData.sess_uuid,
      };
      apiRobotGrade(params).then((res) => {
        if (res.code === 0) {
          this.$emit("change", type);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.msg-option {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  min-width: 120px;
  margin-top: 8px;
  box-sizing: border-box;
  color: #a9a9a9;
  font-size: 14px;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    height: 25px;
    margin-right: 10px;
    padding: 0 10px;
    // width: 50%;
    border-right: 1px solid #dfdfdf;
    background-color: #fff;
    border-radius: 20px;
  }
  .right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    height: 25px;
    padding: 0 10px;
    background-color: #fff;
    border-radius: 20px;
    // width: 50%;
    i {
      margin-right: 2px;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
  .active {
    color: @gold;
  }
}
</style>
